import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { WitgetContainer } from "./CarouselDeporteElements";
import { useSelector } from "react-redux";
import { selectToken } from "../../features/user/userSlice";
import { useCookies } from "react-cookie";
import axios from "axios";
import { API_URL } from "../../const/api";
import IconOverride from "./iconOverride.json";

const CarouselMultiDeporte = () => {
  const [cookies] = useCookies(["user"]);
  const [isHome, setIsHome] = useState(false);
  const [isComponentMounted, setIsComponentMounted] = useState(false);
  const [fondosObject, setFondosObject] = useState({});
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const [count, setCount] = useState(0);

  const token = useSelector(selectToken);
  const location = useLocation();

  useEffect(() => {
    console.log("locacion .net o .com", location.pathname);

    const detectHomePage = () => {
      const isUserOnHomePage = window.location.pathname === "/";
      setIsHome(isUserOnHomePage);
    };

    detectHomePage();
    window.addEventListener("popstate", detectHomePage);

    return () => {
      window.removeEventListener("popstate", detectHomePage);
    };
  }, []);

  useEffect(() => {
    const loadFondos = async () => {
      try {
        const response = await axios.post(API_URL + "getFondosAltenar");
        if (response.data.response) {
          setFondosObject(response.data.response);
          setIsDataLoaded(true);
        } else setCount(count + 1);
      } catch (error) {
        console.error("Error al cargar los fondos:", error);
      }
    };

    loadFondos();
  }, [count]);

  useEffect(() => {
    if ((!isHome && !isComponentMounted) || window.location.pathname !== "/") {
      destroyWidget();
    } else {
      initializeWidget();
      console.info("CarouselMultiDeporte MONTADO");
    }
  }, [isHome, isComponentMounted, isDataLoaded]);

  const initializeWidget = () => {
    if (isHome && isDataLoaded) {
      window.altenarWSDK.init({
        integration: "masterbets365",
        culture: "es-ES",
        token,
      });

      window.SCR = window.altenarWSDK.addWidget({
        widget: "WTopEventsCarousel",
        props: {
          eventCount: 7,
          scrollerControls: 3,
          topEventsType: "liveNow",
          onEventSelect: (event) => {
            console.log("Event selected:", event.liveTime);
            window.location.href =
              event.liveTime !== undefined
                ? location.pathname + "deportes#/liveEvent/" + event.id
                : location.pathname + "deportes#/event/" + event.id;
          },
          onOddSelect: (odd) => {
            window.location.href =
              location.pathname + "deportes#/liveEvent/" + odd.eventId;
          },
          variants: {
            BannerEventBox: 4,
          },
          iconOverride: IconOverride,
          backgroundOverride: {
            sport: {
              68: "https://i.ibb.co/ZxZRk7Q/TENIS.jpg",
            },
            championship: fondosObject, // Usa el objeto de fondos aquí
            event: {
              8928877: "https://i.ibb.co/Cvn1Kp9/PORTUGAL-VS-SUECIA.png",
              8928884: "https://i.ibb.co/QjmTg3r/PAIESES-BAJOS-VS-ESCOCIA.png",
              9226723: "https://i.ibb.co/RhFrPJf/VENEZUELA-VS-ITALIA.png",
              9226729: "https://i.ibb.co/fGmqQvw/ESPA-A-VS-COLOMBIA.png",
              9226731: "https://i.ibb.co/q5gTMCz/PERU-VS-NICARAGUA.png",
              9302526: "https://i.ibb.co/tqBZkGd/76ers-vs-Miami-NBA.png",
              9302529: "https://i.ibb.co/HzxRV1B/Warriors-vs-Nicks-NBA.png",
            },
          },
        },
        container: document.getElementById("container"),
      });

      setIsComponentMounted(true);
    }
  };

  useEffect(() => {
    const scriptUrl = "https://sb2wsdk-altenar2.biahosted.com/altenarWSDK.js";
    const existingScript = document.querySelector(`script[src="${scriptUrl}"]`);

    if (!existingScript) {
      const script = document.createElement("script");
      script.src = scriptUrl;
      script.async = true;
      script.onload = () => {
        if (isDataLoaded && !isComponentMounted) {
          initializeWidget();
        }
      };
      document.body.appendChild(script);
    } else {
      if (isDataLoaded && !isComponentMounted) {
        initializeWidget();
      }
    }
  }, [isDataLoaded, isComponentMounted, isDataLoaded]);

  useEffect(() => {
    if (window.altenarWSDK) {
      if (
        (cookies.MBB === "undefined" || !cookies.MBB) &&
        (cookies.MBA === "undefined" || !cookies.MBA)
      ) {
        initializeWidget();
      }

      if (token !== "") {
        initializeWidget();
        window.altenarWSDK.set({ token });
      }
    }
  }, [cookies.MBA, cookies.MBB, token]);

  const destroyWidget = () => {
    if (window.SCR) {
      window.SCR.remove();
    }

    setIsComponentMounted(false);
  };

  return (
    <>
      <WitgetContainer>
        <div id="container" />
      </WitgetContainer>
    </>
  );
};

export default CarouselMultiDeporte;
